import { AnimatePresence, motion } from "framer-motion";
import { Play, Pause, X } from "lucide-react";
import { usePlayer } from "@/context/PlayerContext";

export default function AudioPlayer() {
  const { current, isPlaying, toggle, stop } = usePlayer();

  return (
    <AnimatePresence>
      {current && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-0 inset-x-0 z-50 backdrop-blur-xl bg-zinc-950/90 border-t border-zinc-800"
          data-testid="audio-player"
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-20 flex items-center gap-4">
            <button
              onClick={toggle}
              className="shrink-0 w-12 h-12 flex items-center justify-center rounded-full bg-rose-600 hover:bg-rose-500 text-white transition-colors"
              data-testid="player-toggle"
              aria-label={isPlaying ? "Pause" : "Play"}
            >
              {isPlaying ? <Pause className="w-5 h-5 fill-current" /> : <Play className="w-5 h-5 fill-current ml-0.5" />}
            </button>

            <span className="flex gap-[3px] h-5 items-end shrink-0">
              {[0, 1, 2, 3, 4].map((i) => (
                <span
                  key={i}
                  className="eq-bar"
                  style={{
                    animationDelay: `${i * 0.12}s`,
                    animationPlayState: isPlaying ? "running" : "paused",
                    height: isPlaying ? undefined : "30%",
                  }}
                />
              ))}
            </span>

            <div className="min-w-0 flex-1">
              <div className="font-display text-xl uppercase text-white leading-none truncate" data-testid="player-title">
                {current.title}
              </div>
              <div className="text-xs text-zinc-500 truncate">{current.artist}</div>
            </div>

            <span className="hidden sm:block font-mono text-[10px] uppercase tracking-widest text-zinc-600">Preview</span>

            <button
              onClick={stop}
              className="shrink-0 w-9 h-9 flex items-center justify-center rounded-full text-zinc-400 hover:text-white hover:bg-zinc-800 transition-colors"
              data-testid="player-close"
              aria-label="Close player"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
